import type { DifficultyTier, TeamSizeTier } from '../../logic/teamSizeUtils'
import styles from './TeamScreen.module.css'

interface DifficultyCardProps {
  tiers: TeamSizeTier[]
  activeTier: DifficultyTier
}

export default function DifficultyCard({ tiers, activeTier }: DifficultyCardProps) {
  return (
    <div className={styles.difficulty}>
      <p className={styles.difficultyHead}>
        <b>How hard do you want to go?</b> More teammates means fewer RMs each person logs.
      </p>
      <div className={styles.tiers}>
        {tiers.map((tier) => (
          <div
            key={tier.id}
            className={[styles.tier, tier.id === activeTier && styles.tierActive]
              .filter(Boolean)
              .join(' ')}
          >
            <div className={styles.tierLabel}>{tier.label}</div>
            <div className={styles.tierValue}>{tier.rangeLabel}</div>
          </div>
        ))}
      </div>
    </div>
  )
}
